import { useState, useEffect } from 'react';
import { downloadFiles, getVendorLedgerData } from '../../Service/ApiService';
import { useNavigate } from '../../../node_modules/react-router-dom/dist/index';
import { showSuccessAlert } from 'utils/SuccessMessage';
import { showAlert } from 'utils/ErrorMessage';
const VendorLedgerController = () => {
  const [ledgerData, setLedgerData] = useState([]);
  const [cloading, setcLoading] = useState(false);
  const user = JSON.parse(localStorage.getItem('user'));

  const [totalDebit, setTotalDebit] = useState(0);
  const [totalCredit, setTotalCredit] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    fetchLedgerData(user.userCode);
  }, []);

  useEffect(() => {
    const totalDebit = ledgerData.reduce((sum, item) => sum + parseFloat(item.debit || 0), 0);
    setTotalDebit(totalDebit);

    const totalCredit = ledgerData.reduce((sum, item) => sum + parseFloat(item.credit || 0), 0);
    setTotalCredit(totalCredit);
  }, [ledgerData]);

  const handleViewClick = (rowData) => {
    const ledgerData = {
      partyCode: rowData.partyCode,
      month: rowData.month,
      year: rowData.year,
      opening: rowData.opening
    };

    localStorage.setItem('ledgerData', JSON.stringify(ledgerData));

    navigate('/vendorledgerDetails');
  };

  const handleDownloadAll = async () => {
    setcLoading(true);
    // const param = `partyCode=${formData.customer.value || user.userCode}`;
    const param = `partyCode=${user.userCode}`;

    // const param = `partyCode=1000`;
    const response = await downloadFiles(param, 'downloadAllpartyvendorLeadger.php', 'vendoroutAll.xls');
    if (response == true) {
      showSuccessAlert('File Downloaded Successfully', 'Download Ledger');
    }

    setcLoading(false);
  };

  const handleDownloadClick = async (rowData) => {
    setcLoading(true);
    const param = `partyCode=${rowData.partyCode}&month=${rowData.month}&year=${rowData.year}&opening=${rowData.opening}`;
    const response = await downloadFiles(param, 'partyvendorledgerDownalod.php', 'vendorledgerFile.xls');
    if (response == true) {
      showSuccessAlert('Ledger File Downloaded Successfully', 'Download Ledger');
    }

    setcLoading(false);
  };

  const fetchLedgerData = async (customerCode) => {
    try {
      setcLoading(true);
      const response = await getVendorLedgerData(customerCode);
      setLedgerData([]);
      if (response && response.success === 'true') {
        setLedgerData(response.ledgerList);
      } else {
        setLedgerData([]);
        showAlert(response.msg);
      }
      setcLoading(false);
    } catch (error) {
      console.error('Error fetching ledger data:', error);
      setcLoading(false);
    }
  };

  return {
    ledgerData,
    totalDebit,
    totalCredit,
    user,
    cloading,
    handleViewClick,
    handleDownloadAll,
    handleDownloadClick
  };
};

export default VendorLedgerController;
